// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3TlHo","buttons":"RemoveExpirationActionButtons_buttons__3gy-F"};